import { getDisablePolling } from '@backoffice-frontend/environment'
import noop from 'lodash/noop'
import { useEffect } from 'react'

/**
 * A hook to repeatedly execute a `callback` after `intervalInMs` passed
 * @param callback function to be executed
 * @param intervalInMs interval to repeat the call at
 * @param polling optional value to explicitly turn polling on or off
 * @returns {null}
 */
export const usePolling = (
  callback: (args: unknown) => unknown,
  intervalInMs: number,
  polling = true,
) => {
  useEffect(() => {
    if (polling && !getDisablePolling() && intervalInMs > 0) {
      const id = setInterval(callback ?? noop, intervalInMs)

      return () => {
        if (id) {
          clearInterval(id)
        }
      }
    }

    return undefined
  }, [callback, intervalInMs, polling])

  return null
}
